import { ItemConversa } from './item-conversa';

export class LigacaoTelemarketing {
  id: number;
  idIntegrador: number;
  integrador: string;
  itensDaConversa: ItemConversa[];
  dataHora: Date;
}
